import React from 'react'
import clsx from 'clsx'
import styles from './UIGameHelpUserSettingsButton.module.scss'
import {Dropdown, T} from '@colonist/ui'
/* eslint-disable no-restricted-imports */
import {getLobbyImagePath} from '../../../../../../code/client/shared/scripts/ui_utils/Utils'
import {LobbyImage, ModeSettingEnum} from '@colonist/types'
import {useUIGameHelpRulesButtonContext} from '../UIGameHelpRulesButton/UIGameHelpRulesButtonContext'
import {useUIGameHelpLeaveGameContext} from '../UIGameHelpLeaveGameContext'
import {useGameStore} from '../../../store/GameStoreContext'
import {useIsReplay} from '../../../store/selectors/useIsReplay'
import {TranslationKeys} from '@colonist/i18n'
import {UIGameFloatingText} from '../../../common/UIGameFloatingText'

export interface UIGameHelpUserSettingsButtonProps {
    className?: string | undefined
    isPlayerSpectator: boolean
    isRulesOptionVisible: boolean
    onSettingsClick: () => void
    onPauseGameClick: () => void
    onDisableKarmaClick: () => void
}

export const UIGameHelpUserSettingsButton = ({
    className,
    isPlayerSpectator,
    isRulesOptionVisible,
    onSettingsClick,
    onPauseGameClick,
    onDisableKarmaClick,
}: UIGameHelpUserSettingsButtonProps) => {
    const {showRulesPopup} = useUIGameHelpRulesButtonContext()
    const {canResign, leaveGame} = useUIGameHelpLeaveGameContext()
    const modeSetting = useGameStore((state) => state.gameSettings.modeSetting)
    const isKarmaActive = useGameStore((state) => state.gameSettings.isKarmaActive)
    const hasUsedDisableKarmaRequest = useGameStore((state) => state.hasUsedDisableKarmaRequest)
    const isReplay = useIsReplay()
    const isBeginnerMode = modeSetting === ModeSettingEnum.BeginnerModeClassic4P

    const getDisableKarmaLabelKey = (): TranslationKeys => {
        if(!isKarmaActive) return 'strings:game.gearIcon.karmaDisabled'
        return 'strings:game.gearIcon.disableKarma'
    }
    const disableKarmaLabelText = <T id={{key: getDisableKarmaLabelKey()}} />
    const handleDisableKarmaClick = () => {
        if(!hasUsedDisableKarmaRequest) onDisableKarmaClick()
    }

    const options: {
        label: React.ReactNode
        onClick: VoidFunction
        hidden?: boolean | undefined
        disabled?: boolean | undefined
    }[] = [
        {
            label: (<T id={{key: 'strings:game.gearIcon.settings'}} />),
            onClick: onSettingsClick,
        },
        {
            label: (<T id={{key: 'strings:game.gearIcon.pauseGame'}} />),
            onClick: onPauseGameClick,
            disabled: isPlayerSpectator,
            hidden: isReplay,
        },
        {
            label: hasUsedDisableKarmaRequest ? (
                <UIGameFloatingText
                    direction="up"
                    text={{key: 'strings:game.gameState.gameLogs.youCanOnlyStartAVoteToDisableKarmaOnce'}}>
                    {disableKarmaLabelText}
                </UIGameFloatingText>
            ) : (
                disableKarmaLabelText
            ),
            onClick: handleDisableKarmaClick,
            disabled: isPlayerSpectator || !isKarmaActive || hasUsedDisableKarmaRequest,
            hidden: isReplay || isBeginnerMode,
        },
        {
            label: (<T id={{key: 'strings:rulebook.title'}} />),
            onClick: showRulesPopup,
            hidden: !isRulesOptionVisible,
        },
        {
            label: (<div className={styles.red}>
                <T id={{key: 'strings:game.gearIcon.resignGame'}} />
            </div>),
            onClick: leaveGame,
            hidden: canResign === false || isPlayerSpectator || isReplay,
        },
        {
            label: (
                <div className={styles.red}>
                    <T id={{key: 'strings:game.gearIcon.leaveGame'}} />
                </div>
            ),
            onClick: leaveGame,
            hidden: (canResign === true && !isPlayerSpectator),
        },
    ]

    return (
        <div>
            <Dropdown
                className={styles.dropdownContainer}
                options={options}
                placement='right-start'>
                <img
                    className={clsx(styles.settingsButton, className)}
                    src={getLobbyImagePath(LobbyImage.Settings)}/>
            </Dropdown>
        </div>
    )
}
